import { render, staticRenderFns } from "./SecretDatabaseStats.vue?vue&type=template&id=7c7b82dd&scoped=true&"
import script from "./SecretDatabaseStats.vue?vue&type=script&lang=js&"
export * from "./SecretDatabaseStats.vue?vue&type=script&lang=js&"
import style0 from "./SecretDatabaseStats.vue?vue&type=style&index=0&id=7c7b82dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7b82dd",
  null
  
)

export default component.exports